require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/.store/core-js@2.6.12/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 866
// module chunks = 75